"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleAuthProvider = exports.auth = exports.storage = exports.functions = exports.db = exports.fbConfig = void 0;
var end2end_1 = require("@hudled/end2end");
var app_1 = __importDefault(require("firebase/compat/app"));
require("firebase/compat/auth");
require("firebase/compat/firestore");
require("firebase/compat/functions");
require("firebase/compat/storage");
var firestore_1 = require("firebase/firestore");
var constants_1 = require("./constants");
var logging_1 = require("./logging");
var prodConfig = {
    apiKey: 'AIzaSyBWYbZJll32PxAs-cJxduU_cCAeuxa2Kmk',
    // authDomain: IS_RECHARGLY ? 'rechargly.com' : 'hudled-5cfe5.firebaseapp.com',
    authDomain: 'hudled-5cfe5.firebaseapp.com',
    databaseURL: 'https://hudled-5cfe5.firebaseio.com',
    projectId: 'hudled-5cfe5',
    storageBucket: 'hudled-5cfe5.appspot.com',
    messagingSenderId: '911255856416',
    appId: end2end_1.IS_RECHARGLY ? '1:911255856416:web:0f58d3d58363b9abcf6345' : '1:911255856416:web:cb29f3cf5d166c37cf6345',
    measurementId: 'G-CYBRQJHGTK',
};
var stagingConfig = {
    apiKey: 'AIzaSyAZBHyVjyaC4lAvLxlz8ZhAlxUiMdXQknc',
    authDomain: 'staging-hudled.firebaseapp.com',
    databaseURL: 'https://staging-hudled.firebaseio.com',
    projectId: 'staging-hudled',
    storageBucket: 'staging-hudled.appspot.com',
    messagingSenderId: '1013085242796',
    appId: '1:1013085242796:web:edc856afc700c081792609',
    measurementId: 'G-QGHC877G7W',
};
var devConfig = {
    apiKey: 'AIzaSyCYOiWaCLU3XWAa5OMDiJ6NK_vko4BUa_k',
    authDomain: 'hudled-dev.firebaseapp.com',
    databaseURL: 'https://hudled-dev.firebaseio.com',
    projectId: 'hudled-dev',
    storageBucket: 'hudled-dev.appspot.com',
    messagingSenderId: '814664013617',
    appId: '1:814664013617:web:f8e2296f32016c951f8210',
};
var CONFIG_MAPPER = {
    staging: stagingConfig,
    prod: prodConfig,
    dev: devConfig,
};
exports.fbConfig = CONFIG_MAPPER[constants_1.FB_ENV_FE];
var firebaseApp = !app_1.default.apps.length ? app_1.default.initializeApp(exports.fbConfig) : app_1.default.app();
// Use functions emulator for cloud function development and debugging
(0, firestore_1.initializeFirestore)(firebaseApp, { ignoreUndefinedProperties: true });
exports.db = app_1.default.firestore();
exports.db.settings({ ignoreUndefinedProperties: true });
exports.functions = app_1.default.functions();
exports.storage = app_1.default.storage();
exports.auth = app_1.default.auth();
exports.googleAuthProvider = new app_1.default.auth.GoogleAuthProvider();
// if (IS_RECHARGLY) {
//   auth.tenantId = 'Rechargly-hnq4g';
// }
(0, logging_1.logInfo)('running this', process.env.REACT_APP_LOCAL_SERVER);
if (process.env.REACT_APP_LOCAL_SERVER) {
    (0, logging_1.logInfo)('is using local emulator');
    exports.functions.useEmulator('localhost', 5001);
    // ToDo: see if the emulator works properly after update to firebase 9.20
    exports.db.useEmulator('localhost', 8080);
    exports.storage.useEmulator('localhost', 9050);
    exports.auth.useEmulator('http://localhost:9099');
}
exports.default = firebaseApp;
